import React from 'react'
import parse from 'html-react-parser'
import PropTypes from 'prop-types'

const AdditionalNote = ({ copy }) => {
  return (
    <div className="bg-primary-lightest p-4 rounded-lg mt-12 mb-6 shadow-md">
      <div className="block border-l-2 border-secondary pl-4 py-1 markdown">
        <div className="mb-3">
          <h4 className="text-secondary text-lg font-semibold">Note</h4>
        </div>
        <div className="-mb-4 text-lg">{parse(copy)}</div>
      </div>
    </div>
  )
}

AdditionalNote.propTypes = {
  copy: PropTypes.string,
}

export default AdditionalNote
